const findByDealId = dealDetails => Object.keys(dealDetails).find(dealId => {
  const deal = dealDetails[dealId];
  const {
    creditApp
  } = deal;
  const {
    creditAppNotified = false,
    creditAppSubmittedFlag = false
  } = creditApp;
  return creditAppSubmittedFlag === false && !creditAppNotified;
});
const remindCreditApp = dealDetails => dealDetails[findByDealId(dealDetails)];
export { remindCreditApp as default };
